import { z } from 'zod';
export const AlertsSearchSchema = z.object({
  /** 詳細サイドパネルで開いているアラート。未指定ならパネルを出さない */
  alertId: z.string().optional(),
  freeText: z.string().default(''),
  pageIndex: z.number().default(0),
  pageSize: z.number().default(50)
});
export type AlertsSearchParams = z.infer<typeof AlertsSearchSchema>;